import styled from 'styled-components';
import { Button } from "@material-ui/core";
import {
    AssignmentOutlined as AssignmentOutlinedIcon,
    InfoOutlined as InfoOutlinedIcon,
    WorkOutline as WorkOutlineIcon,
    DescriptionOutlined as DescriptionOutlinedIcon,
    ExpandMoreOutlined as ExpandMoreOutlinedIcon,
    ThumbUpAltOutlined as ThumbUpAltOutlinedIcon,
    ThumbDownAltOutlined as ThumbDownAltOutlinedIcon
} from '@material-ui/icons';

import { ApplicationsListItem } from "components/ApplicationsList";
import {CrossButtonBlack} from "components/Buttons/CrossButton";

export const Container = styled.div`
  padding: 1rem 0.5rem;
  background-color: #fff;
  height: calc(100% - 78px);
  overflow-y: auto;
`

export const StyledApplicationsListItem = styled(ApplicationsListItem)`
  border-bottom: none;
`

export const CandidateDetailsContainer = styled.div`
  margin-top: 1.5rem;
  padding: 1.275rem 1rem;
  border-radius: 8px;
  background-color: #F3F6F7;
`

export const ScoreSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1.275rem;
  margin-bottom: 1.275rem;
  border-bottom: solid 1px rgba(0, 0, 0, 0.2);
`

export const ScoreContainer = styled.div`
  display: flex;
  align-items: center;
`

export const Score = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: #fff;
  min-width: 174px;
  border-radius: 8px;
  color: #000;
  font-size: 1.875rem;
  font-weight: 600;

  @media (max-width: 465px) {
    min-width: auto;
    font-size: 1.5rem;
  }
`

export const ScoreLabel = styled.div`
  margin-left: 1rem;
  color: #000;
  font-size: 1.25rem;
  font-weight: 600;
  
  @media (max-width: 465px) {
    font-size: 0.875rem;
  }
`

export const InfoButton = styled.div`
  display: flex;
  margin-left: 1rem;
`

export const StyledInfoOutlinedIcon = styled(InfoOutlinedIcon)`
  width: 20px !important;
  height: 20px !important;
  color: rgba(0, 0, 0, 0.56);
`

export const InfoSection = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.275rem;
  
  &:last-child {
    margin-bottom: 0;
  }
`

export const InfoSectionContent = styled.div`
  margin-left: 1rem;
`

export const InfoSectionItemTitle = styled.div`
  margin-bottom: 0.25rem;
  color: #000;
  opacity: 60%;
  font-size: 0.8rem;
  line-height: 1.4;
  font-weight: 700;
`

export const StyledWorkOutlineIcon = styled(WorkOutlineIcon)`
  color: #0B4598;
`;

export const StyledAssignmentOutlinedIcon = styled(AssignmentOutlinedIcon)`
  color: #0B4598;
`;

export const StyledThumbUpAltOutlinedIcon = styled(ThumbUpAltOutlinedIcon)`
  color: var(--primary-main, #FB7672);
`;

export const StyledThumbDownAltOutlinedIcon = styled(ThumbDownAltOutlinedIcon)`
  color: var(--primary-main, #FB7672);
`;

export const CheckboxContainer = styled.div`
  margin: 1.5rem 0;
`;

export const CheckboxLabel = styled.div`
  color: rgba(0, 0, 0, 0.87);
  font-size: 1rem;
  
  @media (max-width: 465px) {
    font-size: 0.75rem;
  }
`

export const ButtonsContainer = styled.div`
  position: relative;
  margin-bottom: 1rem;
`;

export const ButtonsRowContainer = styled(ButtonsContainer)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledDescriptionOutlinedIcon = styled(DescriptionOutlinedIcon)`
  color: #0B4598;
`

export const StyledDescriptionOutlinedIconWhite = styled(DescriptionOutlinedIcon)`
  color: #fff;
`

export const StyledExpandMoreOutlinedIcon = styled(ExpandMoreOutlinedIcon)`
  color: #fff;
`

export const ResumeButton = styled(Button)`
  color: #0B4598 !important;
  border-color: #0B4598 !important;
`

export const PopupContainer = styled.div`
  padding: 1.5rem 1rem;
  border-radius: 8px;
  background: white;
`

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.75rem;
`

export const PopupTitle = styled.div`
  width: 100%;
  text-align: center;
  font-size: 1.2rem;
  line-height: 1.4;
  font-weight: 600;

  @media (max-width: 465px) {
    font-size: 1rem;
  }
`

export const StyledCrossButtonBlack = styled(CrossButtonBlack)`
  width: 1rem;
`

export const PopupDescription = styled.div`
  margin-bottom: 1.75rem;
  line-height: 1.5;
`

export const PopupButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const PopupButton = styled(Button)`
  width: 48% !important;
`

export const PopupLink = styled.div`
  color: #0B4598;
`

export const Description = styled.div`
  padding-top: 1rem;
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.875rem;
`;

export const SkillsTitle = styled.div`
  padding: 1rem 0.5rem 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
`;

export const SkillsContainer = styled.div`
  padding: 0 0.5rem;
`;

export const SkillsLabel = styled.div`
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.875rem;
`;

export const WorkExperienceContainer = styled.div`
  padding: 0 0.5rem;
`;

export const WorkExperienceEntry = styled.div`
  margin-bottom: 1rem;
`;

export const JobTitle = styled.div`
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
`;

export const JobDates = styled.div`
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.875rem;
`;

export const CompanyName = styled(JobDates)`
  margin-bottom: 0.25rem;
`;

